import * as React from "react";
import {
  BODetailTopBar,
  BODetailTopBarItem
} from "app/components/BOComponents/BODetailTopBar/BODetailTopBar";

const MerchantsGeneralTopBar = () => {
  return (
    <BODetailTopBar>
      <BODetailTopBarItem text="List" link={`/snapscan/ops/merchants/list`} />
      <BODetailTopBarItem
        text="Tag Cloud"
        link={`/snapscan/ops/merchants/tag_cloud`}
      />
    </BODetailTopBar>
  );
};

export default MerchantsGeneralTopBar;
